import type { Brand } from '@vcn/ui'
import { links } from '../links'

export type PanelContent = {
  brand: Brand
  /** Sichtbarer Produktname, auch als Screenreader-Label der Kachel. */
  name: string
  headline: string[]
  primary: { label: string; href: string }
  secondary: { label: string; href: string }
}

export const panels: PanelContent[] = [
  {
    brand: 'cap',
    name: 'CAP',
    headline: ['Der Standard', 'für Kooperationen.'],
    primary: { label: 'Mehr Infos', href: links.cap },
    secondary: { label: 'Jetzt kontaktieren', href: links.contactCap },
  },
  {
    brand: 'carrierhub',
    name: 'Carrier Hub',
    headline: ['Weniger Dark.', 'Mehr Fiber.'],
    primary: { label: 'Mehr Infos', href: links.carrierhub },
    secondary: { label: 'Jetzt kontaktieren', href: links.contactCarrierhub },
  },
]

export const footerLinks = [
  { label: 'Impressum', href: links.imprint },
  { label: 'Datenschutz', href: links.privacy },
  { label: 'vitroconnect.com', href: links.corporate },
]

export const ui = {
  skipToContent: 'Zum Inhalt springen',
  toCarrierHub: 'Zum Carrier Hub',
  legal: 'Rechtliches',
}
